export default __webpack_public_path__ + "static/media/star.616894d1.svg";